import clsx from 'clsx';
// Update the import path below to the correct relative path if needed
import Structure from '../Structure';
import __isEmpty from 'lodash/isEmpty';
import { useViewport } from 'hooks/3catinfo/useViewport';
import { FilaProps } from './Fila.types';
import styles from './fila.module.scss';

export default function Fila(props: Readonly<FilaProps>) {
    const { tipus, estil, className, columnes, columnesMobile, ordreMobile, marginBottom } = props;
    const { zoomNavigator } = useViewport();
    let { numColumnsRow } = props;
    const rowClass = 'row' + tipus;
    const colClass = 'col' + columnes;

    const colMobileClass = 'colMobile' + columnesMobile;

    const stylesRow = clsx(
        'fila',
        styles.row,
        ordreMobile === 'reverse' && styles.reverse,
        rowClass && tipus && styles[rowClass],
        estil && styles[estil],
        marginBottom && styles[marginBottom],
        zoomNavigator === 1.5 && estil === 'slider' && styles.zoom150
    );

    const stylesCol = clsx(
        !__isEmpty(columnes) && styles[colClass],
        !__isEmpty(columnesMobile) && styles[colMobileClass],
        className
    );

    if (!__isEmpty(numColumnsRow) && columnes) {
        const widthColumn = Array.isArray(numColumnsRow) && numColumnsRow.length > 0 ? numColumnsRow[0] : 12;
        const cols = columnes.split('_');
        numColumnsRow = cols.map((value: string) => (widthColumn / 12) * Number(value));
    } else {
        numColumnsRow = columnes ? columnes.split('_').map(Number) : [12];
    }

    const getContent = () => {
        if (!__isEmpty(props?.children)) {
            return props.children;
        } else {
            return <Structure {...props} numColumnsRow={numColumnsRow} />;
        }
    };

    return <div className={`${stylesRow} ${stylesCol}`}>{getContent()}</div>;
}
